const asset = require('./asset');
const blockTransformer = require('./block');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');

const createLink = (entry, type = 'Asset') => {
  return {
    sys: {
      type: 'Link',
      linkType: type,
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      title: entry.fields.title?.['nb-NO'],
      url: entry.fields.url?.['nb-NO'],
      bodytext: [],
      image: null
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.image && entry.fields.image['nb-NO'] && isResolvedResource(entry.fields.image['nb-NO'])) {
      result.image = asset.contentfulToInternal(entry.fields.image['nb-NO']);
    }

    // Handle bodytext content blocks:
    if (entry.fields.bodytext && entry.fields.bodytext['nb-NO'] && isResolvedCollection(entry.fields.bodytext['nb-NO'])) {
      result.bodytext = entry.fields.bodytext['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    // Update status based on content blocks status
    result.bodytext.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(page) {
    const result = {
      fields: {
        title: {
          'nb-NO': page.title
        },
        url: {
          'nb-NO': page.url
        },
        bodytext: [],
        image: null
      }
    };

    if (page.bodytext) {
      result.fields.bodytext = {
        'nb-NO': page.bodytext.map((bt) => createLink(bt, 'Entry'))
      };
    }

    // Images:
    if (page.image) {
      result.fields.image = {
        'nb-NO': createLink(page.image, 'Asset')
      };
    }

    return result;
  }
};
